<script setup lang="ts">
// Japan fund page UI Task 6: BGA + JH Signal-tab body, moved verbatim out of
// Dashboard.vue's signal-tab `v-else` branch. Plan 2026-10-04 Task 3: the
// SparklineBar (BGA/JH split: JH sparkline series/label) moved out to
// BgaSparklineStrip/JhSparklineStrip, rendered by the shell above this
// wrapper. Follow-up (2026-10-04 housekeeping): the NewsTickerBar BGA-only
// guard now reads the `showNewsTicker` prop (driven by
// FUND_PAGES[slug].showNewsTicker in the registry) instead of calling
// `usePortfolio` directly — Dashboard.vue passes it only to this component.
import SignalPanel from '../SignalPanel.vue'
import HoldingsPanel from '../HoldingsPanel.vue'
import NewsTickerBar from '../NewsTickerBar.vue'
import type { SignalTabCtx } from '../nav/fundPages'

defineProps<{ ctx: SignalTabCtx; showNewsTicker?: boolean }>()
</script>

<template>
  <NewsTickerBar v-if="showNewsTicker" />
  <SignalPanel :shared-signal="ctx.intSignal" :shared-enriched-nav="ctx.intEnriched" :active-fund-return-pct="ctx.activeFundReturnPct" :active-fund-return-is-shadow="ctx.activeFundReturnIsShadow ?? false" />
  <HoldingsPanel />
</template>
